import { TCameras } from '@r1-frontend/api-domru/api-request/v1/user/request-by-connection/dto/RequestDto';

import type { IState, TCamera } from '~/src/features/videocontrol/Provider/types';

type TGetLabels = (cameras: Record<number, TCamera>, getCamera: (elem: number) => TCamera) => string[];

type TGetResult = (state: IState, getCamera: (elem: number) => TCamera, cameras: Record<number, TCamera>) => TCameras[];

export const getLabelsCameras: TGetLabels = (cameras, getCamera) => {
    const fullBuy = 2;
    return [...Array(Object.values(cameras).length || 1)].map((data, key) => {
        if (!getCamera(key)?.name) {
            return 'null';
        }
        return ` ${getCamera(key)?.name} | ${getCamera(key)?.operType === fullBuy ? 'Покупка' : 'Рассрочка'}`;
    });
};

export const getResultData: TGetResult = (state, getCamera, cameras) => {
    return [...Array(Object.values(cameras).length || 1)].map((data, key) => {
        return {
            cp: state.installLocation?.priceTotal || null,
            p: state.installLocation?.name,
            id: getCamera(key)?.id,
            pr: getCamera(key)?.priceTotal || getCamera(key)?.priceMonth || null,
            ot: getCamera(key)?.operType,
            ld: getCamera(key)?.service,
            pn: state.plan?.name,
            pp: state.plan?.priceMonth || state.plan?.oldPrice,
            vn: state.plan?.subService,
            vp: state.planOption?.priceMonth || null,
            ct: getCamera(key)?.count,
        };
    });
};
